import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { Phone, MapPin, Clock, Mail } from 'lucide-react';
import { LegalModal } from './LegalModal';
export const Footer = () => {
  const {
    t
  } = useLanguage();
  const [modalConfig, setModalConfig] = useState<{
    isOpen: boolean;
    type: 'privacy' | 'terms';
  }>({
    isOpen: false,
    type: 'privacy'
  });
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const openModal = (type: 'privacy' | 'terms') => {
    setModalConfig({
      isOpen: true,
      type
    });
  };
  const dummyContent = <>
      <p data-id="element-92">This is a placeholder for the legal document.</p>
      <p data-id="element-93">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua.
      </p>
      <p data-id="element-94">
        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
        dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
        proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
      </p>
    </>;
  return <footer className="bg-brand-navy-deep pt-14 md:pt-20 pb-8" data-id="element-95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-96">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12 md:mb-16 text-center md:text-left" data-id="element-97">
          {/* Column 1 - Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-98">
            <div className="flex flex-col items-center md:items-start" data-id="element-99">
              <span className="font-script font-bold text-[32px] text-white leading-none" data-id="element-100">
                TwoGirls <span className="text-brand-gold" data-id="element-101">♡</span> MopCo
              </span>
              <span className="text-brand-gold font-montserrat font-medium text-[10px] tracking-[3px] mt-2" data-id="element-102">
                {t('brand.tagline')}
              </span>
              <div className="w-[60px] h-[1px] bg-brand-gold mt-4" data-id="element-103" />
            </div>
            <p className="font-inter text-white italic opacity-65 mt-5 md:mt-6 text-[14px] leading-[1.8] max-w-[280px] md:max-w-none" data-id="element-104">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Column 2 - Services */}
          <div data-id="element-105">
            <h4 className="font-montserrat font-bold text-white text-lg mb-4 md:mb-6" data-id="element-106">
              {t('footer.s.title')}
            </h4>
            <ul className="space-y-2 md:space-y-3" data-id="element-107">
              {['services.c1.title', 'services.c2.title', 'services.c3.title', 'services.c4.title', 'services.c5.title'].map((key, i) => <li key={i} data-id="element-108">
                  <button onClick={() => scrollTo('services')} className="font-inter text-white/75 hover:text-brand-gold transition-colors text-center md:text-left text-[14px] leading-[1.8] min-h-[32px] w-full md:w-auto" data-id="element-109">
                    {t(key)}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div data-id="element-110">
            <h4 className="font-montserrat font-bold text-white text-lg mb-4 md:mb-6" data-id="element-111">
              {t('footer.c.title')}
            </h4>
            <ul className="space-y-3 md:space-y-4" data-id="element-112">
              <li className="flex items-center justify-center md:justify-start gap-3 text-white/80" data-id="element-113">
                <Phone size={16} className="text-brand-gold flex-shrink-0" data-id="element-114" />
                <a href="tel:7866603720" className="font-inter text-[14px] hover:text-brand-gold transition-colors min-h-[24px] flex items-center" data-id="element-115">
                  (786) 660-3720
                </a>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-3 text-white/80" data-id="element-116">
                <Mail size={16} className="text-brand-gold flex-shrink-0" data-id="element-117" />
                <a href="mailto:twomopgirlsco@gmail.com" className="font-inter text-[14px] hover:text-brand-gold transition-colors break-all min-h-[24px] flex items-center" data-id="element-118">
                  twomopgirlsco@gmail.com
                </a>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-3 text-white/80" data-id="element-119">
                <MapPin size={16} className="text-brand-gold flex-shrink-0" data-id="element-120" />
                <span className="font-inter text-[14px]" data-id="element-121">
                  Miami and Broward Area
                </span>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-3 text-white/80" data-id="element-122">
                <Clock size={16} className="text-brand-gold flex-shrink-0" data-id="element-123" />
                <span className="font-inter text-[14px]" data-id="element-124">
                  {t('trust.hours')}
                </span>
              </li>
            </ul>
          </div>

          {/* Column 4 - Service Area */}
          <div data-id="element-125">
            <h4 className="font-montserrat font-bold text-white text-lg mb-4 md:mb-6" data-id="element-126">
              {t('footer.a.title')}
            </h4>
            <p className="font-inter text-white/75 leading-[1.8] text-[14px] max-w-[320px] mx-auto md:mx-0" data-id="element-127">
              {t('footer.a.desc')}
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-brand-gold/20 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left" data-id="element-128">
          <div className="flex flex-col md:flex-row items-center gap-3 md:gap-8" data-id="element-129">
            <span className="font-inter text-white/50 text-[13px] md:text-sm" data-id="element-130">
              {t('footer.rights')}
            </span>
            <div className="flex gap-4" data-id="element-131">
              <button onClick={() => openModal('privacy')} className="font-inter text-white/50 hover:text-brand-gold text-[13px] md:text-sm transition-colors min-h-[32px]" data-id="element-132">
                {t('footer.privacy')}
              </button>
              <button onClick={() => openModal('terms')} className="font-inter text-white/50 hover:text-brand-gold text-[13px] md:text-sm transition-colors min-h-[32px]" data-id="element-133">
                {t('footer.terms')}
              </button>
            </div>
          </div>
          <span className="font-inter text-brand-gold text-[13px] md:text-sm font-medium" data-id="element-134">
            Website by Eleven Studio ✦
          </span>
        </div>
      </div>

      <LegalModal isOpen={modalConfig.isOpen} onClose={() => setModalConfig({
      ...modalConfig,
      isOpen: false
    })} title={modalConfig.type === 'privacy' ? t('footer.privacy') : t('footer.terms')} content={dummyContent} data-id="element-135" />
    </footer>;
};